import { motion } from "framer-motion";
import TopRuler from "../components/TopRuler";
import RadarWidget from "../components/RadarWidget";

function Header({ className = "" }) {
  return (
    <header className={`relative z-10 ${className}`}>
      <div className="lg:grid grid-cols-[240px_1fr_130px] xl:grid-cols-[240px_1fr_240px] items-center h-full pt-24 lg:pt-0">
        <div className="pl-6 flex items-center">
          <div className="absolute -top-6 md:-top-12 -left-6 md:-left-12">
            <svg version="1.1" id="Layer_1" x="0px" y="0px" 
              className="w-[280px] h-[63px] sm:w-[350px] sm:h-[79px] md:w-[400px] md:h-[90px] lg:w-[445px] lg:h-[100px]"
              viewBox="0 0 445 100">
              <path d="M444.5,0v69l-30.4,30.5H0V0H444.5z" />
              <motion.path 
                stroke="white" 
                fill="none" 
                d="M444.5,0v69l-30.4,30.5H0" 
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{
                  duration: 0.5,
                  delay: 0,
                  ease: "easeInOut"
                }}
              />
              <g>
                {/* Outline strokes first */}
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.5, 
                    delay: 0.05,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M100,66.5v-35h17.7c2.3,0,4.1,0.7,5.5,2.1c1.4,1.4,2.1,3.2,2.1,5.5v2.5c0,2-0.5,3.5-1.5,4.6s-2.1,1.7-3.3,1.8
		v0.4c1.5,0.2,2.8,0.8,4,2.1c1.2,1.2,1.8,2.8,1.8,4.9V59c0,2.2-0.7,4-2.1,5.4s-3.2,2.1-5.5,2.1L100,66.5L100,66.5z M114.6,44.9
		c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.6,0.4-1.2v-2.8c0-0.5-0.1-0.8-0.4-1.1c-0.3-0.3-0.7-0.4-1.2-0.4H109v5.9H114.6z M115.6,59
		c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1V54c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.7-0.4-1.1-0.4H109V59H115.6z"/>
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.4, 
                    delay: 0.15,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M151.9,66.5h-23.3v-35h9v26.8h14.3V66.5L151.9,66.5z" />
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.5, 
                    delay: 0.25,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M163.5,31.5h11.6l9.4,30.7v4.2h-8.9l-1.4-6h-9.8l-1.4,6H154v-4.2L163.5,31.5z M169.1,39.9l-2.9,12.7h6.2
		l-2.9-12.7H169.1L169.1,39.9z"/>
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.4, 
                    delay: 0.35,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M194,66.5c-2.2,0-4-0.7-5.4-2.1c-1.4-1.4-2.1-3.2-2.1-5.4V39c0-2.3,0.7-4.1,2.1-5.5c1.4-1.4,3.2-2.1,5.4-2.1
		h16.9v5.6l-2.6,2.5H197c-0.5,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.2v15.5c0,0.5,0.1,0.9,0.4,1.2s0.7,0.4,1.1,0.4h13.8v8.2
		L194,66.5L194,66.5z"/>
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.5, 
                    delay: 0.45,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M222.8,66.5h-9v-35h9v13.1h4.2l6.6-13.1h7.5v4.3l-6.2,12.2l6.9,14v4.3h-8.3L227,53.1h-4.2V66.5z" />
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.4, 
                    delay: 0.55,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M245,66.5v-35h17.7c2.3,0,4.1,0.7,5.5,2.1c1.4,1.4,2.1,3.2,2.1,5.5v2.5c0,2-0.5,3.5-1.5,4.6
		c-1,1.1-2.1,1.7-3.3,1.8v0.4c1.5,0.2,2.8,0.8,4,2.1c1.2,1.2,1.8,2.8,1.8,4.9V59c0,2.2-0.7,4-2.1,5.4c-1.4,1.4-3.2,2.1-5.5,2.1
		L245,66.5L245,66.5z M259.6,44.9c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.6,0.4-1.2v-2.8c0-0.5-0.1-0.8-0.4-1.1
		c-0.3-0.3-0.7-0.4-1.2-0.4H254v5.9H259.6z M260.6,59c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1V54c0-0.5-0.1-0.9-0.4-1.2
		c-0.3-0.3-0.7-0.4-1.1-0.4H254V59H260.6z"/>
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 0.65,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M282.6,66.5h-9v-35h9V66.5z" />
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.5, 
                    delay: 0.75,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M314.6,62.1v4.3h-8.9l-5.4-12h-4.6v12h-9v-35h19.5c2.3,0,4.1,0.7,5.4,2.1c1.4,1.4,2.1,3.2,2.1,5.5v8
		c0,1.7-0.5,3.1-1.4,4.2c-0.9,1.1-2,1.8-3.1,2.1L314.6,62.1L314.6,62.1z M304.7,41.3c0-0.5-0.1-0.9-0.4-1.2
		c-0.3-0.3-0.7-0.4-1.2-0.4h-7.4v6.7h7.4c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.7,0.4-1.2V41.3z"/>
                <motion.path
                  initial={{ pathLength: 0, opacity: 1 }}
                  animate={{ pathLength: 1 }}
                  transition={{ 
                    duration: 0.4, 
                    delay: 0.85,
                    ease: "easeInOut"
                  }}
                  stroke="white" 
                  strokeWidth="1"
                  fill="none"
                  d="M317.9,66.5v-35h19.6c2.3,0,4.1,0.7,5.5,2.1c1.4,1.4,2.1,3.2,2.1,5.5v20c0,2.2-0.7,4-2.1,5.4
		c-1.4,1.4-3.2,2.1-5.5,2.1L317.9,66.5L317.9,66.5z M334.5,58.3c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.2V41.3
		c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.7-0.4-1.1-0.4h-7.6v18.7L334.5,58.3L334.5,58.3z"/>
                
                {/* Filled versions appear after outlines complete */}
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.5,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M100,66.5v-35h17.7c2.3,0,4.1,0.7,5.5,2.1c1.4,1.4,2.1,3.2,2.1,5.5v2.5c0,2-0.5,3.5-1.5,4.6s-2.1,1.7-3.3,1.8
		v0.4c1.5,0.2,2.8,0.8,4,2.1c1.2,1.2,1.8,2.8,1.8,4.9V59c0,2.2-0.7,4-2.1,5.4s-3.2,2.1-5.5,2.1L100,66.5L100,66.5z M114.6,44.9
		c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.6,0.4-1.2v-2.8c0-0.5-0.1-0.8-0.4-1.1c-0.3-0.3-0.7-0.4-1.2-0.4H109v5.9H114.6z M115.6,59
		c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1V54c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.7-0.4-1.1-0.4H109V59H115.6z"/>
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.55,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M151.9,66.5h-23.3v-35h9v26.8h14.3V66.5L151.9,66.5z" />
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.6,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M163.5,31.5h11.6l9.4,30.7v4.2h-8.9l-1.4-6h-9.8l-1.4,6H154v-4.2L163.5,31.5z M169.1,39.9l-2.9,12.7h6.2
		l-2.9-12.7H169.1L169.1,39.9z"/>
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.65,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M194,66.5c-2.2,0-4-0.7-5.4-2.1c-1.4-1.4-2.1-3.2-2.1-5.4V39c0-2.3,0.7-4.1,2.1-5.5c1.4-1.4,3.2-2.1,5.4-2.1
		h16.9v5.6l-2.6,2.5H197c-0.5,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.2v15.5c0,0.5,0.1,0.9,0.4,1.2s0.7,0.4,1.1,0.4h13.8v8.2
		L194,66.5L194,66.5z"/>
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.7,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M222.8,66.5h-9v-35h9v13.1h4.2l6.6-13.1h7.5v4.3l-6.2,12.2l6.9,14v4.3h-8.3L227,53.1h-4.2V66.5z" />
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.75,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M245,66.5v-35h17.7c2.3,0,4.1,0.7,5.5,2.1c1.4,1.4,2.1,3.2,2.1,5.5v2.5c0,2-0.5,3.5-1.5,4.6
		c-1,1.1-2.1,1.7-3.3,1.8v0.4c1.5,0.2,2.8,0.8,4,2.1c1.2,1.2,1.8,2.8,1.8,4.9V59c0,2.2-0.7,4-2.1,5.4c-1.4,1.4-3.2,2.1-5.5,2.1
		L245,66.5L245,66.5z M259.6,44.9c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.6,0.4-1.2v-2.8c0-0.5-0.1-0.8-0.4-1.1
		c-0.3-0.3-0.7-0.4-1.2-0.4H254v5.9H259.6z M260.6,59c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1V54c0-0.5-0.1-0.9-0.4-1.2
		c-0.3-0.3-0.7-0.4-1.1-0.4H254V59H260.6z"/>
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.8,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M282.6,66.5h-9v-35h9V66.5z" />
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.85,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M314.6,62.1v4.3h-8.9l-5.4-12h-4.6v12h-9v-35h19.5c2.3,0,4.1,0.7,5.4,2.1c1.4,1.4,2.1,3.2,2.1,5.5v8
		c0,1.7-0.5,3.1-1.4,4.2c-0.9,1.1-2,1.8-3.1,2.1L314.6,62.1L314.6,62.1z M304.7,41.3c0-0.5-0.1-0.9-0.4-1.2
		c-0.3-0.3-0.7-0.4-1.2-0.4h-7.4v6.7h7.4c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.7,0.4-1.2V41.3z"/>
                <motion.path
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 1.9,
                    ease: "easeInOut"
                  }}
                  fill="white" d="M317.9,66.5v-35h19.6c2.3,0,4.1,0.7,5.5,2.1c1.4,1.4,2.1,3.2,2.1,5.5v20c0,2.2-0.7,4-2.1,5.4
		c-1.4,1.4-3.2,2.1-5.5,2.1L317.9,66.5L317.9,66.5z M334.5,58.3c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.2V41.3
		c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.7-0.4-1.1-0.4h-7.6v18.7L334.5,58.3L334.5,58.3z"/>
              </g>
            </svg>
            <div className="sr-only">Blackbird</div>
          </div>
        </div>
        <div className="py-6 flex flex-col items-center opacity-40 overflow-hidden"><TopRuler /></div>
        <div className="p-6 xl:p-12 hidden lg:flex opacity-40 justify-end items-end">
          <RadarWidget />
        </div>
      </div>
    </header>
  );
}

export default Header;